export default __webpack_public_path__ + "static/Laura-White-Barton-39814dfc0014292826cc13cb4664f532.jpg";